export default function (err) {
  return err && err.status === 403;
}
